// @ts-nocheck
import axios from 'axios';

import { BASE_URL } from '../../../../queries/useDataEngine';

const documentTemplateUrl = `${BASE_URL}/documenttemplateupload`;

export const DocumentTemplateService = {
  getDocumentTemplates: () => axios.get(documentTemplateUrl, { loader: false }),
  uploadDocumentTemplate: (body) =>
    axios.post(documentTemplateUrl, body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  deleteDocumentTemplate: (params) =>
    axios.delete(documentTemplateUrl, { params }),
  createDocument: (body) => axios.post(`${BASE_URL}/documenttemplate`, body),
  fetchSharableLink: (params) =>
    axios.get(`${BASE_URL}/documentonedriveview`, { params }),
  downloadTemplateDocument: (params, config = {}) =>
    axios.get(`${BASE_URL}/documenttemplatedownload`, {
      params,
      responseType: 'arraybuffer',
      ...config,
    }),
};
